// const SRV = "http://93.190.43.170";
// const SRV = "http://95.216.67.122"; // htz
// const SRV = "http://app.defiwatch.biz"; // htz
const SRV = "https://api.defiwatch.biz"; // htz
const SRV_PORT = ""; // ":4000"

export const apiUrl = SRV + SRV_PORT + "/api/";
export const apiYieldsUrl = SRV + SRV_PORT + "/api/yields/";
export const apiChartsUrl = SRV + SRV_PORT + "/api/charts/";
// export const pyApiPortfolioUrl = SRV + ":5000/api/portfolio";
